module.exports = __webpack_public_path__ + "static/img/040 2.735d3863.jpg";